import dayjs from "dayjs";
import { approveIcon, rejectIcon } from "../utils/svg";
import { useState } from "react";
import PtoDetails from "../utils/ptodetails";
import { humangrey } from "../../landingscreen/modals/svgs";

export const PTORequestsTable = ({ data = [], ptostatusupdate,loading, onApprove, onReject }) => {
  const fmt = (iso) => dayjs(iso).format("MMM D, YYYY");
const [ptoinfo,setPtoInfo]=useState(false)
const[selectedemp,setSelectedEmp]=useState({})
  return (
    <div className="w-full overflow-hidden rounded-xl border border-gray-200 bg-white">
      {/* Scroll container — cap height to 80% of viewport */}
      <div className="max-h-[80vh] overflow-auto">
        <table className="w-full text-center min-w-full">
          <thead className="sticky top-0 z-10 bg-[#50869A]">
            <tr>
              <th className="w-12 px-4 py-3">
                <input type="checkbox" className="h-4 w-4" />
              </th>
              <th className="px-4 py-3 text-[#FFFFFF] font-medium text-sm font-inter text-left">
                Employee Name
              </th>
              <th className="px-4 py-3 text-[#FFFFFF] font-medium text-sm font-inter">
                Start Date
              </th>
              <th className="px-4 py-3 text-[#FFFFFF] font-medium text-sm font-inter">
                End Date
              </th>
              <th className="px-4 py-3 text-[#FFFFFF] font-medium text-sm font-inter">
                Request Type
              </th>
              <th className="px-4 py-3 text-[#FFFFFF] font-medium text-sm font-inter">
                Total Hours
              </th>
              <th className="px-4 py-3 text-[#FFFFFF] font-medium text-sm font-inter text-right">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="px-4 py-10 text-center text-gray-500">
                  Loading...
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-4 py-10 text-center text-gray-500">
                  No PTO requests.
                </td>
              </tr>
            ) : (
              data.map((r) => (
                <tr key={r.id} className="bg-white border-b">
                  <td className="px-4 py-3">
                    <input type="checkbox" className="h-4 w-4" />
                  </td>
                  <td className="px-4 py-3 text-left">
                    <div className="flex items-center gap-3">
                     <div className="cursor-pointer" onClick={()=>{
                      setSelectedEmp(r)
                      setPtoInfo(true)
                     }}>
                      
                       {humangrey}
                      </div>
                      <div className="flex flex-col">
                        <span className="font-medium text-[#111827] font-inter text-sm">
                          {r.emp_name}
                        </span>
                        <span className="text-xs text-[#6B7280] font-inter font-normal">
                          {r.emp_role}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-[#374151] font-normal font-inter text-sm text-center">
                    {fmt(r.start_date)}
                  </td>
                  <td className="px-4 py-3 text-[#374151] font-normal font-inter text-sm text-center">
                    {fmt(r.end_date)}
                  </td>
                  <td className="px-4 py-3 text-center">
                    <span className="inline-flex rounded-full px-2.5 py-1.5 text-[12px] bg-[#E5E7EB] text-[#202224] font-inter font-medium">
                      {r.request_type}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-[#374151] font-inter text-[14px] font-normal">
                    {r.total_hours}
                  </td>
                  <td className="px-4 py-3">
                    {r?.status==='Approved'?<><div className="text-green-700 bg-green-200 py-1  rounded-full">Approved</div></>:
                    r?.status==='Denied'?<><div className="bg-red-100 text-red-700  py-1  rounded-full">Denied</div></>:<div className="flex items-center justify-end gap-2">
                      <button
                        onClick={() =>ptostatusupdate({status:"Approved",id:r.id})}
                        className="grid h-7 w-7 place-items-center rounded-md bg-[#DCFCE7] focus:outline-none"
                        aria-label="Approve"
                      >
                        {approveIcon}
                      </button>
                      <button
                             onClick={() =>ptostatusupdate({status:"Denied",id:r.id})}
                        className="grid h-7 w-7 place-items-center rounded-md bg-[#FEE2E2] focus:outline-none"
                        aria-label="Reject"
                      >
                        {rejectIcon}
                      </button>
                    </div>}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
       {ptoinfo && (
              <PtoDetails
                employee={selectedemp}
                onClose={() => setPtoInfo(null)}
              />
            )}
    </div>
  );
};
